import axios from "axios";
import { BASE_URL } from "../config/apiConfig";
import { AuthService } from "./authService";

export const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    Accept: "application/json, text/plain, */*",
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use((request) => {
  const token = AuthService.getToken();

  if (token) {
    request.headers.Authorization = `Bearer ${token}`;
  } else {
    delete request.headers.Authorization;
  }

  return request;
});
